import {Legend} from '../../../service/Legend'

const setFeature = async (context, payload) => {

}
export default {
  setFeature
}
